import { gql } from "@apollo/client";

import IOperation from "api/IOperation";

import {QueryPromoCodeStatus, QueryPromoCodeVariables} from "gql/types/queries/PromoCodeQuery";

const text = gql`query PromoCodeQuery($queryPromoCodeInput: QueryPromoCodeInput!) { 
    promoCodeStatus(queryPromoCodeInput: $queryPromoCodeInput) {
        status,
        percentOff
    }
}`

const PromoCodeQuery: IOperation<QueryPromoCodeStatus, QueryPromoCodeVariables> = { text } as any;

export default PromoCodeQuery;